import { render, staticRenderFns } from "./DetailedForm.vue?vue&type=template&id=61910272&scoped=true&"
import script from "./DetailedForm.vue?vue&type=script&lang=js&"
export * from "./DetailedForm.vue?vue&type=script&lang=js&"
import style0 from "./DetailedForm.vue?vue&type=style&index=0&id=61910272&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61910272",
  null
  
)

export default component.exports